import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { AppSettings } from '../../PRE-LOAD/app-settings';

import { Observable } from 'rxjs';
import { AppInsightsMonitoringService } from './appInsightsMonitoring.service';
import { E2eService } from '../e2e/e2e.service';


@Injectable()
export class HttpAppInsightsMonitorInterceptor implements HttpInterceptor {

    constructor(
        private appSettings: AppSettings,
        private appInsights: AppInsightsMonitoringService,
        private e2eService: E2eService
    ) { }

    /**
     * @description Intercepts HTTP requests and adds App Insights headers.
     *
     * In order to facilitate tracking sessions and users through App Insights, the backend API is configured
     * to accept headers to associate these sessions with backend API requests
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.url.includes(".json") == false) {
            // If we've made if this far then clone the request and set the header.
            var req = request.clone({
                headers: request.headers.set('x-appInsights-userId', this.appInsights.userId).set("x-appInsights-correlationId", this.e2eService.correlationReference)
            });

            if (this.appInsights.appInsights.context.getSessionId() != null) {
                req = req.clone({
                    headers: req.headers.set("x-appInsights-sessionId", this.appInsights.appInsights.context.getSessionId())
                });

            }

            // End by returning the new request.
            return next.handle(req);
        }
        return next.handle(request);
    }
}
